/* eslint-disable no-useless-constructor */
import React, { useRef, useEffect, useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import styles from './Confirmation.module.scss'
import PrintComponent from './PrintComponent'
import SaveCopy from './SaveCopy'

export const PrintContent1 = ({ t, i18n, emailAddress, paymentTransactionNum, transId, transOwner }) => {
  // const t = this.props.t
  // const i18n = this.props.i18n
  // const emailAddress = this.props.emailAddress
  // const paymentTransactionNum = this.props.paymentTransactionNum
  const handleGoBackToStart = (e) => {
    e.preventDefault();
    const url = i18n.language === 'en'
      ? 'https://beta.novascotia.ca/change-your-address-registry-motor-vehicles'
      : 'https://beta.novascotia.ca/fr/changement-dadresse-bureau-des-vehicules-automobiles'

    window.location.replace(url);
  }

  return (
    <div className={"container"}>
      <div style={{ display: "flex" }} >
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "30px" }}>
          <div className={"col-xs-1 " + styles['success_margin_right']}><i className="fa fa-check-circle fa-2x" aria-hidden="true"></i></div>
          <div style={{ flexGrow: 1, backgroundColor: "green", width: "5px" }} />
        </div>

        <div style={{ flexGrow: 1 }}>
          {/*  */}
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-12">
                <h1 style={{ color: "green" }}>{t('confirmation.title')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-lg-12">
                <h2>{t('confirmation.transaction_number')} <strong>{paymentTransactionNum}</strong></h2>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-lg-10">
                <p style={{ marginBottom: '10px' }}>
                  {t('confirmation.we_have_emailed')} <br />
                  {t('confirmation.print_or_save')}
                </p>
              </div>
            </div>

            <div className="print_no_display">
              <div className="row" >
                <div style={{ display: "flex", flexGrow: 1 }} > {/*className="col-xs-12 col-lg-10" */}
                  <div className={styles['display_flex']}>
                    <div className={styles['back_center']}>
                      {typeof InstallTrigger !== 'undefined' || /*@cc_on!@*/ false || !!document.documentMode ? null : (
                        <PrintComponent transId={transId} transOwner={transOwner} />
                      )}
                      <SaveCopy transId={transId} transOwner={transOwner} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  {/* eslint-disable-next-line */}
                  <a href={"#"} className={styles['all_finished_link']} onClick={handleGoBackToStart}>{t('confirmation.all_finished')}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ConfirmationView = ({ t, i18n, setIsError }) => {
  const pageElem = useRef()
  const location = useLocation()

  const [paymentTransactionNum, setPaymentTransactionNum] = useState('')
  const [transId, setTransId] = useState('123456')
  const [transOwner, setTransOwner] = useState('test Test')
  const [emailAddress, setEmailAddress] = useState('')

  const { registeredByname, nsHealthCard, driverLicence, registeredByName, jointlyRegistered, registeredBusiness } = useSelector((state) => state.app.addressTypeChange)

  useEffect(() => {
    try {
      // dispatch(clearAllAction())
      // dispatch(logoutAction()).catch((e) => {
      //   console.log(e)
      // })
      if (!location.state) {
        return;
      }
      if (location.state.transNum) {
        setPaymentTransactionNum(location.state.transNum)
      }
      if (location.state.emailAddress) {
        setEmailAddress(location.state.emailAddress);
      }
      if (location.state.transId) {
        setTransId(location.state.transId);
      }
      if (location.state.transOwner) {
        setTransOwner(location.state.transOwner);
      }
      if (location.state && location.state.transNum && location.state.emailAddress && location.state.transId && location.state.transOwner) {

        setTransId(location.state.transId)
        setTransOwner(location.state.transOwner)
        setEmailAddress(location.state.emailAddress)
      } else {
        // history.push(`/${i18n.language}${t('routes.privacy_notice')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [location.state, setIsError])

  const isRMV = useMemo(() => {
    return driverLicence || registeredByName || jointlyRegistered || registeredBusiness
  }, [driverLicence, registeredByName, jointlyRegistered, registeredBusiness]);


  const addressChangedProcessInfo = useMemo(() => {
    let message = isRMV ? t('shared.registry_of_motor_vehicles') : ""
    if (isRMV && nsHealthCard) {
      message += ` ${t('shared.and')}`
    }
    message = nsHealthCard ? message + ` ${t('shared.medavie_blue_cross')}` : message

    return message;
  }, [nsHealthCard, t, isRMV]);

  return (
    <React.Fragment>
      <div ref={pageElem} id="Tets">
        <PrintContent1 i18n={i18n} t={t} emailAddress={emailAddress} paymentTransactionNum={paymentTransactionNum} transId={transId} transOwner={transOwner} />
        <div className="container">

          <div className="row">
            <div className="col-xs-12 col-lg-12">
              <h2>{t('confirmation.what_happens_next')}</h2>
              <div className="row">
                <div className="col-xs-12">
                  <p><strong>{t('confirmation.confirmation_email')}</strong>
                    <br />
                    {t('confirmation.confirmation_email_info')}
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12">
                  <p><strong>{t('confirmation.address_change_process')}</strong>
                    <br />
                    {t('confirmation.address_change_process_info')}
                    {addressChangedProcessInfo}. {t('confirmation.your_address_change_reviewed')}
                  </p>
                </div>
              </div>

              {(driverLicence || registeredByname) && (
                <div className="row">
                  <div className="col-xs-12">
                    <p><strong>{t('confirmation.address_change_rejected')}</strong>
                      <br />
                      {t('confirmation.address_change_rejected_info')}
                    </p>
                  </div>
                </div>
              )}

              {nsHealthCard && (
                <div className="row">
                  <div className="col-xs-12">
                    <p><strong>{t('confirmation.address_change_rejected_medavie')}</strong>
                      <br />
                      {t('confirmation.address_change_rejected_medavie_info')}
                    </p>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-xs-12">
                  <p>
                    <strong>
                      {t('confirmation.health_card_update_heading_pre')}
                      <a href="https://www.novascotia.ca/update-your-health-card-information" target="_blank" rel="noopener noreferrer">
                        {t('confirmation.health_card_update_link')}
                      </a>
                      {t('confirmation.health_card_update_heading_suffix')}
                    </strong>
                    <br />
                    {t('confirmation.health_card_update_info')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(ConfirmationView)